// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({"1367": "ModelViewer","2257": "EthereumWallet","582": "NftSecondaryMarketModal","7530": "ActionToast","7581": "NftPdpZoomModal","8692": "RecentlyViewed",}[chunkId] || chunkId) + ".543.0.0." + {"1367": "8716a277130d6a58","2257": "e8b86da6c047c57f","2973": "b4ed4158e5df3817","582": "740fd541a16ff672","7530": "9162c50566ce07d8","7581": "74c90eca207d51e4","8692": "756b11d5e6972054",}[chunkId] + ".css"
}